import { getIdOrNull, requestWithPromise } from '..'
import { HttpMethods } from '../apiHelper'
import apiClient from './apiClient'

export const getSectorContactPersons = (user, { sector }) => {
  return requestWithPromise(
    `/api/sectors/${getIdOrNull(sector)}/contact-persons`,
    HttpMethods.GET,
    null,
    user
  )
}

export const getSectionContactPersons = (user, { section }) => {
  return requestWithPromise(
    `/api/school-sections/${getIdOrNull(section)}/contact-persons`,
    HttpMethods.GET,
    null,
    user
  )
}

export const getSchoolContactPersons = (user, school, parameters = {}) =>
  apiClient.get(user, `api/schools/${getIdOrNull(school)}/contact-persons`, parameters)

export const getSchoolSpecialitiesContactPersons = (user, school, parameters = {}) =>
  apiClient.get(user, `api/schools/${getIdOrNull(school)}/specialities-contact-persons`, parameters)
